import { render } from "preact";
import { ClerkProvider, getClerkPublishableKey } from "./auth/clerk";
import { App } from "./app/App";
import "./styles.css";

const PUBLISHABLE_KEY = getClerkPublishableKey();

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY");
}

const root = document.getElementById("app");

if (!root) {
  throw new Error("Missing #app root element");
}

render(
  <ClerkProvider
    publishableKey={PUBLISHABLE_KEY}
    afterSignInUrl="/"
    afterSignUpUrl="/"
  >
    <App />
  </ClerkProvider>,
  root
);
